import { z } from 'zod/v3';
import { OutputProcessingEventDetailsSchema } from './OutputProcessingEventDetailsSchema';

export const OutputProcessingGroupEventDetailsSchema = z.object({
  dataObjectName: z.string().nullable(),
  processingEventDetails: OutputProcessingEventDetailsSchema,
});
